import { get } from 'vuex-pathify';
export default {
  computed: {
    isCircularSectorSelectionModuleEnabled: get('admin/additionalModules@CIRCULAR_SECTOR_SELECT.enabled'),
    circularSectorSelectionButton() {
      return this.isCircularSectorToolVisible
        ? [
            {
              name: 'circularSectorSelection',
              icon: 'mdi-angle-acute',
              tooltip: this.$i18n.t('button.circularSectorSelection'),
              fontSize: '19px',
            },
          ]
        : [];
    },
    isCircularSectorToolVisible() {
      return this.isCircularSectorSelectionModuleEnabled && this.hasGeometry;
    },
  },
  methods: {
    circularSectorSelectionAction() {
      this.$router.push({ name: 'circularSectorSelection', params: { lid: this.currentLayer?.id } });
    },
  },
};
